export function end() {
  const end = document.querySelector('.js-end')
  let header_h = 0;
  if (window.matchMedia('(max-width: 1000px)').matches) {
    header_h = 50;
  } else if (window.matchMedia('(min-width:1001px)').matches) {
    header_h = 80;
  }

  window.addEventListener('scroll', () => {
    const target_t = end.getBoundingClientRect().top;
    const target_b = end.getBoundingClientRect().bottom;
    const window_h = window.innerHeight;
    const scroll_t = window.pageYOffset;

    if(target_t < header_h) {
      end.classList.add('is-active');
    } else {
      end.classList.remove('is-active');
    }

    if (target_b <= window_h) {
      end.classList.add('is-end');
    } else {
      end.classList.remove('is-end'); // ★ここが add になっていました
    }
  })
}